import ImagePlaceholder from './imagePlaceholder'

export default ImagePlaceholder
